var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDersertIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1470_3144)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.96875 5.60313L6.59375 5.23438L6.21875 5.60313L6.59375 5.97213L6.96875 5.60313Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.10547 4.36719L5.85547 4.61244L6.10547 4.85894L6.35547 4.61244L6.10547 4.36719Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.07422 5.16738L7.32422 5.41362L7.57422 5.16738L7.32422 4.92188L7.07422 5.16738Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.71875 6.54994L6.96875 6.79644L7.21875 6.54994L6.96875 6.30469L6.71875 6.54994Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.32812 5.85156L5.07812 6.09756L5.32812 6.34331L5.57812 6.09756L5.32812 5.85156Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.21875 4.73578L7.09375 4.61328L6.96875 4.73578L7.09375 4.85928L7.21875 4.73578Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.39844 4.02875L5.27344 3.90625L5.14844 4.02875L5.27344 4.15225L5.39844 4.02875Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.27344 4.36859L5.14844 4.24609L5.02344 4.36859L5.14844 4.49184L5.27344 4.36859Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.19922 5.97456L7.32422 6.09756L7.44922 5.97456L7.32422 5.85156L7.19922 5.97456Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.45312 6.46675L5.57812 6.58975L5.70312 6.46675L5.57812 6.34375L5.45312 6.46675Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.59375 7.11469L6.71875 7.23819L6.84375 7.11469L6.71875 6.99219L6.59375 7.11469Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6016 6.10884L12.9766 5.73959L12.6016 5.37109L12.2266 5.73959L12.6016 6.10884Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3594 4.74575L12.1094 4.5L11.8594 4.74575L12.1094 4.99175L12.3594 4.74575Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4375 4.09366L10.6875 4.33966L10.9375 4.09366L10.6875 3.84766L10.4375 4.09366Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7461 7.23769L11.4961 6.99219L11.2461 7.23769L11.4961 7.48394L11.7461 7.23769Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.332 5.54644L13.582 5.30044L13.332 5.05469L13.082 5.30044L13.332 5.54644Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8672 5.54262L11.6172 5.29688L11.3672 5.54262L11.6172 5.78863L11.8672 5.54262Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2266 4.86909L13.1016 4.74609L12.9766 4.86909L13.1016 4.99209L13.2266 4.86909Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2344 3.97066L12.1094 3.84766L11.9844 3.97066L12.1094 4.09366L12.2344 3.97066Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.207 6.10688L13.332 6.23038L13.457 6.10688L13.332 5.98438L13.207 6.10688Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7461 6.74384L11.8711 6.86709L11.9961 6.74384L11.8711 6.62109L11.7461 6.74384Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6875 4.77534L10.8125 4.89809L10.9375 4.77534L10.8125 4.65234L10.6875 4.77534Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1016 7.30584L12.2266 7.42934L12.3516 7.30584L12.2266 7.18359L12.1016 7.30584Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.95312 1.79263L8.70312 1.54688L8.45312 1.79263L8.70312 2.03863L8.95312 1.79263Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.98828 2.77691L9.23828 2.53116L8.98828 2.28516L8.73828 2.53116L8.98828 2.77691Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.20312 3.35928L8.45312 3.60503L8.70312 3.35928L8.45312 3.11328L8.20312 3.35928Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.35156 1.63787L9.22656 1.51562L9.10156 1.63787L9.22656 1.76137L9.35156 1.63787Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.97656 2.1535L9.85156 2.03125L9.72656 2.1535L9.85156 2.27725L9.97656 2.1535Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.57812 2.27509L8.45312 2.15234L8.32812 2.27509L8.45312 2.39834L8.57812 2.27509Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.07812 2.89644L8.20312 3.01944L8.32812 2.89644L8.20312 2.77344L8.07812 2.89644Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.44922 1.54878L7.32422 1.42578L7.19922 1.54878L7.32422 1.67178L7.44922 1.54878Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.20312 1.30269L8.07812 1.17969L7.95312 1.30269L8.07812 1.42569L8.20312 1.30269Z",
    fill: "#FF885A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter32_d_1470_3144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 6.60675C15.5 5.56425 14.9602 4.7865 14.0472 4.2285C13.4618 3.623 12.671 3.19825 11.7773 3.05225C11.2438 1.5715 9.75525 0.5 8 0.5C6.27525 0.5 4.808 1.534 4.2505 2.9745C3.67875 2.332 3.144 1.72775 3.0435 1.60325C2.80475 1.3065 2.26725 0.7945 1.6055 0.7945C0.11675 0.7945 0.147 1.77175 1.6055 1.838C2.023 1.857 2.73725 2.52675 3.40675 3.27025C2.85628 3.47998 2.35869 3.80824 1.94925 4.23175C1.03875 4.78925 0.5 5.56575 0.5 6.60675C0.5 10.2583 3.54475 12.2753 7.412 12.46C7.3095 12.8453 7.1885 13.186 7.04675 13.46C5.51575 13.5805 4.3885 13.9825 4.3885 14.4613C4.38875 15.0353 6.00575 15.5 8 15.5C9.99475 15.5 11.6112 15.0353 11.6112 14.4613C11.6112 13.9827 10.4862 13.581 8.957 13.4605C8.818 13.187 8.699 12.846 8.5975 12.4595C12.46 12.272 15.5 10.2552 15.5 6.60675ZM14.5775 6.55825C14.081 7.9215 11.515 8.55875 8.36675 8.60425C8.70425 8.055 8.9025 7.42125 8.9025 6.74275C8.9025 6.02425 8.68225 5.35475 8.30725 4.78375C8.9455 3.99675 9.95475 3.485 11.0925 3.485C12.9527 3.48475 14.474 4.84775 14.5775 6.55825ZM8 0.99175C9.45175 0.99175 10.6977 1.822 11.2247 2.99925C11.1802 2.998 11.1368 2.993 11.0922 2.993C9.8465 2.993 8.73475 3.5335 8.00225 4.37525C7.269 3.5325 6.1545 2.993 4.90775 2.993C4.865 2.993 4.82325 2.99775 4.78075 2.999C5.30775 1.8225 6.54925 0.99175 8 0.99175ZM1.4225 6.55825C1.526 4.84775 3.04725 3.485 4.9075 3.485C6.8345 3.485 8.40225 4.9465 8.40225 6.74275C8.40225 7.4355 8.1675 8.077 7.7705 8.6055C4.5605 8.57675 1.92625 7.94125 1.4225 6.55825ZM9.7085 9.67225C8.643 9.75275 7.57125 9.73725 6.51375 9.60925C5.4565 9.48375 4.41075 9.25475 3.419 8.888C4.464 9.057 5.504 9.1745 6.547 9.22675C7.589 9.27475 8.6325 9.26925 9.668 9.18225C10.7038 9.102 11.735 8.948 12.7355 8.68775C13.2325 8.55125 13.7273 8.39375 14.1853 8.16475C14.4152 8.053 14.6335 7.919 14.8255 7.75375C15.013 7.589 15.1775 7.37875 15.2072 7.1165C15.2327 7.3805 15.0993 7.64475 14.9245 7.848C14.7488 8.055 14.5325 8.223 14.3083 8.37225C13.8542 8.66475 13.357 8.8795 12.8503 9.053C11.834 9.4005 10.772 9.58 9.7085 9.67225Z",
    fill: "#FF885A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1470_3144",
    x: 1.21875,
    y: 5.23438,
    width: 10.75,
    height: 15.7383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1470_3144",
    x: 0.855469,
    y: 4.36719,
    width: 10.5,
    height: 15.4922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1470_3144",
    x: 2.07422,
    y: 4.92188,
    width: 10.5,
    height: 15.4922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1470_3144",
    x: 1.71875,
    y: 6.30469,
    width: 10.5,
    height: 15.4922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1470_3144",
    x: 0.078125,
    y: 5.85156,
    width: 10.5,
    height: 15.4922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1470_3144",
    x: 1.96875,
    y: 4.61328,
    width: 10.25,
    height: 15.2461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1470_3144",
    x: 0.148438,
    y: 3.90625,
    width: 10.25,
    height: 15.2461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_1470_3144",
    x: 0.0234375,
    y: 4.24609,
    width: 10.25,
    height: 15.2461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_1470_3144",
    x: 2.19922,
    y: 5.85156,
    width: 10.25,
    height: 15.2461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_1470_3144",
    x: 0.453125,
    y: 6.34375,
    width: 10.25,
    height: 15.2461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_1470_3144",
    x: 1.59375,
    y: 6.99219,
    width: 10.25,
    height: 15.2461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_1470_3144",
    x: 7.22656,
    y: 5.37109,
    width: 10.75,
    height: 15.7383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_1470_3144",
    x: 6.85938,
    y: 4.5,
    width: 10.5,
    height: 15.4922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_1470_3144",
    x: 5.4375,
    y: 3.84766,
    width: 10.5,
    height: 15.4922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_1470_3144",
    x: 6.24609,
    y: 6.99219,
    width: 10.5,
    height: 15.4922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_1470_3144",
    x: 8.08203,
    y: 5.05469,
    width: 10.5,
    height: 15.4922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_1470_3144",
    x: 6.36719,
    y: 5.29688,
    width: 10.5,
    height: 15.4922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_1470_3144",
    x: 7.97656,
    y: 4.74609,
    width: 10.25,
    height: 15.2461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_1470_3144",
    x: 6.98438,
    y: 3.84766,
    width: 10.25,
    height: 15.2461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_1470_3144",
    x: 8.20703,
    y: 5.98438,
    width: 10.25,
    height: 15.2461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_d_1470_3144",
    x: 6.74609,
    y: 6.62109,
    width: 10.25,
    height: 15.2461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_d_1470_3144",
    x: 5.6875,
    y: 4.65234,
    width: 10.25,
    height: 15.2461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_d_1470_3144",
    x: 7.10156,
    y: 7.18359,
    width: 10.25,
    height: 15.2461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d_1470_3144",
    x: 3.45312,
    y: 1.54688,
    width: 10.5,
    height: 15.4922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_d_1470_3144",
    x: 3.73828,
    y: 2.28516,
    width: 10.5,
    height: 15.4922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_d_1470_3144",
    x: 3.20312,
    y: 3.11328,
    width: 10.5,
    height: 15.4922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_d_1470_3144",
    x: 4.10156,
    y: 1.51562,
    width: 10.25,
    height: 15.2461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_d_1470_3144",
    x: 4.72656,
    y: 2.03125,
    width: 10.25,
    height: 15.2461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_d_1470_3144",
    x: 3.32812,
    y: 2.15234,
    width: 10.25,
    height: 15.2461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_d_1470_3144",
    x: 3.07812,
    y: 2.77344,
    width: 10.25,
    height: 15.2461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_d_1470_3144",
    x: 2.19922,
    y: 1.42578,
    width: 10.25,
    height: 15.2461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_d_1470_3144",
    x: 2.95312,
    y: 1.17969,
    width: 10.25,
    height: 15.2461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_d_1470_3144",
    x: -4.5,
    y: 0.5,
    width: 25,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_3144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_3144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1470_3144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDersertIcon);
export default __webpack_public_path__ + "static/media/dersert-icon.31087107bd134d0524e5e42e97d46ea6.svg";
export { ForwardRef as ReactComponent };